import { render, staticRenderFns } from "./GalleryCreate.vue?vue&type=template&id=84ff5e08"
import script from "./GalleryCreate.vue?vue&type=script&lang=js"
export * from "./GalleryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports